import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Accordion from "@mui/joy/Accordion";
import AccordionDetails from "@mui/joy/AccordionDetails";
import AccordionGroup from "@mui/joy/AccordionGroup";
import AccordionSummary from "@mui/joy/AccordionSummary";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import TabPanel from "@mui/joy/TabPanel";
import Tab, { tabClasses } from "@mui/joy/Tab";
import Input from "@mui/joy/Input";
import FormControl from "@mui/joy/FormControl";
import {
  createGlobalOption,
  updateGlobalOption,
  deleteGlobalOption,
} from "../../utils/api/options";
import Radio from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import Chip from "@mui/joy/Chip";
import Tooltip from "@mui/joy/Tooltip";
import Card from "@mui/joy/Card";

import Button from "@mui/joy/Button";

import Checkbox from "@mui/joy/Checkbox";
import { setGlobalData } from "../../utils/companySlice";
import { timestampToISO } from "../../utils/helperFunctions";
import { getAllCollection } from "../../utils/api/options";
import Select from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import ChipDelete from "@mui/joy/ChipDelete";
import Box from "@mui/joy/Box";
import IconButton from "@mui/joy/IconButton";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AspectRatio from "@mui/joy/AspectRatio";
import Typography from "@mui/joy/Typography";
import GateCard from "./GateCard";
import GateChip from "./GateChip";

const GateBox = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      {children}
    </Box>
  );
};

export default function AddGlobalGateDataPage() {
  const dispatch = useDispatch();

  const companyId = useSelector((state) => state.company.id);

  useEffect(() => {
    getAllGateData();
  }, []);

  const getAllGateData = () => {
    getAllCollection("gateStyles", companyId)
      .then((res) => {
        const newDataList = res.map((option) => {
          return {
            ...option,
            createdAt: timestampToISO(option.createdAt),
            updatedAt: option.updatedAt
              ? timestampToISO(option.updatedAt)
              : null,
          };
        });
        dispatch(
          setGlobalData({
            data: newDataList,
            listName: "globalGateStylesList",
            mapName: "globalGateStylesMap",
          })
        );
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });

    getAllCollection("gateMaterials", companyId)
      .then((res) => {
        const newDataList = res.map((option) => {
          return {
            ...option,
            createdAt: timestampToISO(option.createdAt),
            updatedAt: option.updatedAt
              ? timestampToISO(option.updatedAt)
              : null,
          };
        });
        dispatch(
          setGlobalData({
            data: newDataList,
            listName: "globalGateMaterialsList",
            mapName: "globalGateMaterialsMap",
          })
        );
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });

    getAllCollection("gateAttributes", companyId)
      .then((res) => {
        const newDataList = res.map((option) => {
          return {
            ...option,
            createdAt: timestampToISO(option.createdAt),
            updatedAt: option.updatedAt
              ? timestampToISO(option.updatedAt)
              : null,
          };
        });
        dispatch(
          setGlobalData({
            data: newDataList,
            listName: "globalGateAttributesList",
            mapName: "globalGateAttributesMap",
          })
        );
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });

    getAllCollection("gateItems", companyId)
      .then((res) => {
        const newDataList = res.map((option) => {
          return {
            ...option,
            createdAt: timestampToISO(option.createdAt),
            updatedAt: option.updatedAt
              ? timestampToISO(option.updatedAt)
              : null,
          };
        });
        dispatch(
          setGlobalData({
            data: newDataList,
            mapName: "globalGateItemsMap",
            listName: "globalGateItemsList",
          })
        );
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const globalGateStylesList = useSelector(
    (state) => state.company.globalGateStylesList
  );
  const globalGateMaterialsList = useSelector(
    (state) => state.company.globalGateMaterialsList
  );
  const globalGateMaterialsMap = useSelector(
    (state) => state.company.globalGateMaterialsMap
  );

  const globalGateAttributesList = useSelector(
    (state) => state.company.globalGateAttributesList
  );
  const globalGateAttributesMap = useSelector(
    (state) => state.company.globalGateAttributesMap
  );
  const globalGateItemsMap = useSelector(
    (state) => state.company.globalGateItemsMap
  );
  const globalGateItemsList = useSelector(
    (state) => state.company.globalGateItemsList
  );
  return (
    <AccordionGroup>
      <div>
        <h1>Add Global Data Page</h1>

        <Tabs
          orientation="vertical"
          defaultValue={0}
          sx={{
            bgcolor: "transparent",
          }}
        >
          <TabList
            tabFlex={1}
            size="sm"
            sx={{
              minWidth: 200,
              pl: { xs: 0, md: 4 },
              justifyContent: "left",
              [`&& .${tabClasses.root}`]: {
                fontWeight: "600",
                flex: "initial",
                height: "40px",
                color: "text.tertiary",
                [`&.${tabClasses.selected}`]: {
                  bgcolor: "transparent",
                  color: "text.primary",
                  "&::after": {
                    height: "20px",
                    bgcolor: "primary.500",
                  },
                },
              },
            }}
          >
            <Tab sx={{ borderRadius: "6px 6px 0 0" }} indicatorInset value={0}>
              Gate Styles:
            </Tab>
            <Tab sx={{ borderRadius: "6px 6px 0 0" }} indicatorInset value={1}>
              Gate Materials:
            </Tab>
            <Tab sx={{ borderRadius: "6px 6px 0 0" }} indicatorInset value={2}>
              Gate Attributes:
            </Tab>
            <Tab sx={{ borderRadius: "6px 6px 0 0" }} indicatorInset value={3}>
              Gate Items:
            </Tab>
          </TabList>
          <TabPanel value={0}>
            <h2>Global Gate Styles:</h2>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                const formElements = e.currentTarget.elements;
                const name = formElements.name.value;
                const type = formElements.type.value;
                const array = [];
                globalGateMaterialsList.forEach((item) => {
                  formElements[item.name].checked && array.push(item.id);
                });

                createGlobalOption(
                  {
                    globalGateMaterials: array,
                    name: name,
                    type: type,
                    option: "style",
                    imageUrl: formElements.imageUrl.value || "",
                  },
                  "gateStyles"
                ).then((res) => {
                  getAllGateData();
                });
                formElements.name.value = "";
                formElements.type.value = "";
                formElements.imageUrl.value = "";
              }}
            >
              Add Style:
              <Input required name="name" size="sm" placeholder="Name" />
              <Input required name="type" size="sm" placeholder="Type" />
              <Input name="imageUrl" size="sm" placeholder="Image Url" />
              <Box>
                Materials to add:
                {globalGateMaterialsList.map((item) => {
                  return (
                    <Checkbox
                      sx={{
                        margin: 1,
                        border: "solid 1px grey",
                        borderRadius: 4,
                        padding: 1,
                      }}
                      name={item.name}
                      value={item.id}
                      label={item.name}
                      size="sm"
                    />
                  );
                })}
              </Box>
              <Button type="submit">Submit</Button>
            </form>
            <GateBox sx={{ display: "flex" }}>
              {globalGateStylesList.map((style) => {
                return (
                  <GateCard
                    type="gate"
                    sx={{ width: 400 }}
                    variant="solid"
                    style={{ border: "solid 1px grey", margin: 10 }}
                    data={style}
                    nestedList={style.globalGateMaterials}
                    globalMap={globalGateMaterialsMap}
                    collectionName="gateStyles"
                    getAllGateData={getAllGateData}
                    nestedListName="globalGateMaterials"
                  >
                    <Select defaultValue="">
                      {globalGateMaterialsList.map((item) => {
                        if (style.globalGateMaterials.includes(item.id))
                          return null;
                        return (
                          <Option
                            onClick={() => {
                              const newGlobalGateItemsArray = [
                                ...style.globalGateMaterials,
                                item.id,
                              ];
                              updateGlobalOption(
                                {
                                  id: style.id,
                                  globalGateMaterials: newGlobalGateItemsArray,
                                },
                                "gateStyles"
                              ).then((res) => {
                                getAllGateData();
                              });
                            }}
                            value={item.id}
                          >
                            {item.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </GateCard>
                );
              })}
            </GateBox>
          </TabPanel>
          <TabPanel value={1}>
            <h2>GlobalGate Materials:</h2>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                const formElements = e.currentTarget.elements;
                const name = formElements.name.value;
                const array = [];
                globalGateAttributesList.forEach((item) => {
                  formElements[item.name].checked && array.push(item.id);
                });

                createGlobalOption(
                  {
                    globalGateAttributes: array,
                    name: name,
                    option: "material",
                  },
                  "gateMaterials"
                ).then((res) => {
                  getAllGateData();
                });
                formElements.name.value = "";
              }}
            >
              Add Material:
              <Input
                required
                name="name"
                size="sm"
                placeholder="Material Name"
              />
              <Box>
                Attributes to add:
                {globalGateAttributesList.map((item) => {
                  return (
                    <Checkbox
                      sx={{
                        margin: 1,
                        border: "solid 1px grey",
                        borderRadius: 4,
                        padding: 1,
                      }}
                      name={item.name}
                      value={item.id}
                      label={item.name}
                      size="sm"
                    />
                  );
                })}
              </Box>
              <Button type="submit">Submit</Button>
            </form>

            <GateBox sx={{ display: "flex", flexWrap: "wrap" }}>
              {globalGateMaterialsList.map((material) => {
                return (
                  <GateCard
                    type="gate"
                    variant="solid"
                    style={{ border: "solid 1px grey", margin: 10 }}
                    getAllGateData={getAllGateData}
                  >
                    <IconButton
                      aria-label="bookmark Bahamas Islands"
                      variant="plain"
                      color="neutral"
                      size="sm"
                      sx={{
                        position: "absolute",
                        top: "0.875rem",
                        right: "0.5rem",
                      }}
                    >
                      <DeleteForeverIcon
                        onClick={() => {
                          let hasMaterial = false;
                          let foundInside = [];
                          globalGateStylesList.forEach((style) => {
                            style.globalGateMaterials.forEach((materialId) => {
                              if (materialId === material.id) {
                                hasMaterial = true;
                                foundInside.push(style.name);
                                return;
                              }
                            });
                          });
                          if (hasMaterial) {
                            alert(`Material is in use and cannot be deleted`);
                          } else {
                            deleteGlobalOption(
                              material.id,
                              "gateMaterials"
                            ).then((res) => {
                              getAllGateData();
                            });
                          }
                        }}
                      />
                    </IconButton>
                    <h3>{material.name}</h3>
                    <div
                      style={{
                        gap: 6,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <p style={{ margin: 0 }}>Global Gate Attributes:</p>{" "}
                      {material.globalGateAttributes.map((attributeId) => {
                        return (
                          <GateChip
                            id={attributeId}
                            deleteFunction={() => {
                              const newGlobalGateItemsArray = [
                                ...material.globalGateAttributes,
                              ];
                              const itemIndex =
                                newGlobalGateItemsArray.indexOf(attributeId);
                              newGlobalGateItemsArray.splice(itemIndex, 1);
                              updateGlobalOption(
                                {
                                  id: material.id,
                                  globalGateAttributes: newGlobalGateItemsArray,
                                },
                                "gateMaterials"
                              ).then((res) => {
                                getAllGateData();
                              });
                            }}
                          >
                            {globalGateAttributesMap[attributeId] &&
                              globalGateAttributesMap[attributeId].name}
                          </GateChip>
                        );
                      })}
                    </div>
                    {Object.keys(material).map((key) => {
                      if (key === "globalGateAttributes") return null;
                      return (
                        <div
                          style={{
                            gap: 6,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <p style={{ margin: 0 }}>{key}:</p>{" "}
                          <GateChip>
                            {typeof material[key] === "boolean"
                              ? material[key]
                                ? "true"
                                : "false"
                              : material[key]}
                          </GateChip>
                        </div>
                      );
                    })}
                    <h3>Add Attribute to Material</h3>
                    <Select defaultValue="">
                      {globalGateAttributesList.map((item) => {
                        if (material.globalGateAttributes.includes(item.id))
                          return null;
                        return (
                          <Option
                            onClick={() => {
                              const newGlobalGateItemsArray = [
                                ...material.globalGateAttributes,
                                item.id,
                              ];
                              updateGlobalOption(
                                {
                                  id: material.id,
                                  globalGateAttributes: newGlobalGateItemsArray,
                                },
                                "gateMaterials"
                              ).then((res) => {
                                getAllGateData();
                              });
                            }}
                            value={item.id}
                          >
                            {item.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </GateCard>
                );
              })}
            </GateBox>
          </TabPanel>
          <TabPanel value={2}>
            <h2>GlobalGate Attributes:</h2>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                const formElements = e.currentTarget.elements;
                const name = formElements.name.value;
                // const array = [];
                // globalGateItemsList.forEach((item) => {
                //   formElements[item.name].checked && array.push(item.id);
                // });

                createGlobalOption(
                  { name: name, option: "attribute", globalGateItems: [] },
                  "gateAttributes"
                ).then(() => {
                  getAllGateData();
                });
                formElements.name.value = "";
              }}
            >
              Add Attribute:
              <Input required name="name" size="sm" placeholder="Item Name" />
              {/* {globalGateItemsList.map((item) => {
                return (
                  <Checkbox
                    required
                    sx={{
                      margin: 1,
                      border: "solid 1px grey",
                      borderRadius: 4,
                      padding: 1,
                    }}
                    name={item.name}
                    value={item.id}
                    label={item.name}
                    size="sm"
                  />
                );
              })} */}
              <Button type="submit">Submit</Button>
            </form>

            <GateBox sx={{ display: "flex" }}>
              {globalGateAttributesList.map((attribute) => {
                return (
                  <GateCard
                    type="gate"
                    variant="solid"
                    style={{ border: "solid 1px grey", margin: 10 }}
                    data={attribute}
                    nestedList={attribute.globalGateItems}
                    globalMap={globalGateItemsMap}
                    collectionName="gateAttributes"
                    getAllGateData={getAllGateData}
                    nestedListName="globalGateItems"
                    parentChecklist={globalGateMaterialsList}
                    currentListName="globalGateAttributes"
                  >
                    {attribute["globalGateItems"] && (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          const formElements = e.currentTarget.elements;
                          const name = formElements.name.value;

                          createGlobalOption(
                            {
                              name: name,
                              option: "item",
                              attribute: attribute.id,
                            },
                            "gateItems"
                          ).then((itemId) => {
                            const newGlobalGateItemsArray = [
                              ...attribute["globalGateItems"],
                            ];
                            newGlobalGateItemsArray.push(itemId);
                            updateGlobalOption(
                              {
                                id: attribute.id,
                                globalGateItems: newGlobalGateItemsArray,
                              },
                              "gateAttributes"
                            ).then((res) => {
                              getAllGateData();
                            });
                          });

                          formElements.name.value = "";
                        }}
                      >
                        Create Item for Attribute:
                        <Input
                          required
                          name="name"
                          size="sm"
                          placeholder="Item Name"
                        />
                        <Button type="submit">Submit</Button>
                      </form>
                    )}
                  </GateCard>
                );
              })}
            </GateBox>
          </TabPanel>
          <TabPanel value={3}>
            <h2>GlobalGate Items:</h2>

            <GateBox sx={{ display: "flex" }}>
              {globalGateItemsList.map((style) => {
                const attributeName = globalGateAttributesMap[style.attribute];
                return (
                  <GateCard
                    type="gate"
                    variant="solid"
                    style={{ border: "solid 1px grey", margin: 10 }}
                    getAllGateData={getAllGateData}
                  >
                    <h3>{style.name}</h3>
                    {Object.keys(style).map((key) => {
                      let content = style[key];
                      if (key === "attribute") {
                        content = attributeName && attributeName.name;
                      }
                      return (
                        <div
                          style={{
                            gap: 6,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <p style={{ margin: 0 }}>{key}:</p>{" "}
                          <GateChip>
                            {typeof style[key] === "boolean"
                              ? style[key]
                                ? "true"
                                : "false"
                              : content}
                          </GateChip>
                        </div>
                      );
                    })}
                  </GateCard>
                );
              })}
            </GateBox>
          </TabPanel>
        </Tabs>
      </div>
    </AccordionGroup>
  );
}
